// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('main.siefileexport', {
        url: '/sie',
        templateUrl: 'main/economy/siefileexport/siefileexport.tpl.html',
        controller: 'SieFileExportController as vm',
        resolve: {
            locations: locationsResolver,
            accountMessages: accountMessagesResolver
        }
    });
}

// @ngInject
function locationsResolver(EconomyApiService) {
    return EconomyApiService.getLocations();
}

// @ngInject
function accountMessagesResolver(EconomyApiService) {
    return EconomyApiService.getAccountConfigMessages();
}

// @ngInject
function SieFileExportController($interval, EconomyApiService, loadSpinnerService, locations, accountMessages) {
    var vm = this;

    vm.fromDate = new Date();
    vm.toDate = new Date();
    vm.organizationNumbers = [];
    vm.organizationNumber = "";
    vm.accountMessages = accountMessages;

    vm.fetchSieFile = fetchSieFile;

    activate();

    function activate() {
        _.forEach(locations, function(location) {
            if (!_.find(vm.organizationNumbers, function (num) { return num === location.organizationNumber; })) {
                vm.organizationNumbers.push(location.organizationNumber);
            }
        });
    }

    function fetchSieFile() {
        loadSpinnerService.start('mainSpinner');
        var orgNr = (vm.organizationNumber !== "") ? vm.organizationNumber : "";
        EconomyApiService.downloadSIEFile(vm.fromDate, vm.toDate, vm.organizationNumber).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }

}

angular
    .module('economy.siefileexport', [])
    .config(stateConfig)
    .controller('SieFileExportController', SieFileExportController);


